import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import { SearchStore, SuggestionSet } from './schema/SearchStore';

const defaultSearchState: SearchStore = {
    searchSessionId: '',
    currentQuery: '',
    latestLogicalId: '',
    zeroQuerySuggestions: null, // Initalizing with null so that this variable is reused as areZeroQuerySuggestionsFetched.
    suggestions: new ObservableMap<string, SuggestionSet>(),
    isFetchingSuggestions: false,
    selectedSuggestion: null,
    activeResultsTab: null,
};

const store = createStore<SearchStore>('3SSearchStore', defaultSearchState)();
export const getSearchStore = () => store;
